import axios from 'axios';
import { Dispatch } from 'redux';
import IMPACT_REPORT_TYPES from './types';
import { ENV_CONFIG } from 'config/environment';
import API_ROUTES from 'services/apiRoutes';
import { getSiteAccessToken } from 'services/storage';

const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
};

export const getImpactReport =
  (electionYear: number) =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch(IMPACT_REPORT_TYPES.impactReportStart());

    const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.GET_IMPACT_REPORT(electionYear)}`;

    try {
      const response = await axios.get(url, {
        headers: { ...headers, Authorization: `Bearer ${getSiteAccessToken()}` },
      });
      dispatch(IMPACT_REPORT_TYPES.impactReportSuccess(response.data));
      return Promise.resolve(response);
    } catch (error: any) {
      dispatch(
        IMPACT_REPORT_TYPES.impactReportError(error.message, error.response?.status ?? null)
      );
      return Promise.reject(error);
    }
  };
